<script lang="ts">
  import { campaign_id } from "./filters/store";
  export let img_src = '';
  export let alt = '';
  const src =
    img_src && $campaign_id
      ? `https://cdn-assets.hyperin.com/mot/ilmo/${$campaign_id}/pics/${img_src}`
      : undefined;
</script>

<div class="logo-container text-center">
  {#if src}
    <img loading="lazy" {src} {alt} />
  {/if}
</div>

<style>
  .logo-container {
    overflow: hidden;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
  }
  .logo-container:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
  img {
    position: absolute;
    max-width: 100%;
    width: auto !important;
    height: auto;
    max-height: 100%;
  }
</style>
